/**
 * Normaliza survey_date del API (YYYY-MM-DD, ISO datetime o Date) a clave calendario.
 */
export function toSurveyDateKey(raw) {
    if (raw == null || raw === '') return null;
    if (raw instanceof Date) {
        if (Number.isNaN(raw.getTime())) return null;
        return [
            raw.getFullYear(),
            String(raw.getMonth() + 1).padStart(2, '0'),
            String(raw.getDate()).padStart(2, '0'),
        ].join('-');
    }
    const s = String(raw).trim();
    if (s === '[object Object]') return null;
    const head = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (head) return `${head[1]}-${head[2]}-${head[3]}`;
    const parsed = new Date(s);
    if (Number.isNaN(parsed.getTime())) return null;
    return [
        parsed.getFullYear(),
        String(parsed.getMonth() + 1).padStart(2, '0'),
        String(parsed.getDate()).padStart(2, '0'),
    ].join('-');
}

/** Fecha local al mediodía (evita desfases por zona al formatear). */
export function surveyDateAtNoon(dateKey) {
    const key = toSurveyDateKey(dateKey);
    if (!key) return null;
    const [y, m, d] = key.split('-').map(Number);
    return new Date(y, m - 1, d, 12, 0, 0, 0);
}
